import { createContext } from "react";

export const ChatContext = createContext({
  currentContext: null,
  setCurrentContext: () => {},
  isFullScreen: false,
  setIsFullScreen: () => {},
});
